<template>
  <div class="complete-wrapper absolute flex flex-col">
    <h3 class="complete-info" v-html="message"></h3>
    <img class="complete-icon" src="../../assets/stamp/scan-complete.png" />
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import i18n from '../../i18n';

export default {
  name: 'ScanComplete',
  mixins: [incein],
  props: {
    secondTime: Boolean,
  },
  computed: {
    message() {
      if (this.isIncein) {
        return this.secondTime
          ? i18n.t('incein.scan_complete_2')
          : i18n.t('incein.scan_complete_1');
      }
      return this.secondTime ? i18n.t('stamp.scan_complete_2') : i18n.t('stamp.scan_complete_1');
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-wrapper {
  @apply mx-auto left-0 right-0;
  top: 15%;
  width: 65%;
}
.complete-info {
  @apply text-center font-bold;
  font-size: 30px;
  line-height: 1.39;
  color: rgb(245, 245, 245);
}
.complete-icon {
  @apply mx-auto;
  margin-top: 35%;
  max-width: 150px;
}
</style>
